import React, { useState, useMemo } from "react";
import {
  getCurrentLocalDateTime,
  pad,
  months,
} from "../../../utils/getLocalDateTime";

function useDateDropdown() {
  const today = getCurrentLocalDateTime();

  const [selectMonth, setSelectMonth] = useState(pad(today.month));
  const [selectDate, setSelectDate] = useState(pad(today.date));
  const [selectYear, setSelectYear] = useState(today.year);
  const [selectHour, setSelectHour] = useState(pad(today.hours));
  const [selectMinute, setSelectMinute] = useState(pad(today.minutes));

  const years = new Array(3).fill(today.year).map((year, index) => {
    const value = year - index;
    return {
      label: value,
      value,
    };
  });

  const optionsYears = years;

  const optionsMonths = months
    // .slice(0, today.month)
    .map((_, index) => {
      return {
        label: `${pad(index + 1)}`,
        value: `${pad(index + 1)}`,
        index,
      };
    })
    .reverse();

  const dayOfMonth = months[Number(selectMonth - 1)].days;

  const optionsDates = new Array(dayOfMonth)
    .fill(dayOfMonth)
    // .slice(0, +selectDate)
    .map((_, index) => {
      const value = index + 1;
      return {
        label: `${pad(value)}`,
        value: `${pad(value)}`,
        index,
      };
    })
    .reverse();

  const optionsHours = useMemo(() => {
    return [{ label: "00", value: "00" }]
      .concat(
        new Array(23)
          .fill(23)
          // .slice(0, selectDate < +today.date ? 23 : +today.hours)
          .map((_, index) => {
            const value = index + 1;
            return {
              label: `${pad(value)}`,
              value: `${pad(value)}`,
              index,
            };
          })
      )
      .reverse();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectHour]);

  const optionsMintues = useMemo(() => {
    return [{ label: "00", value: "00" }]
      .concat(
        new Array(59)
          .fill(59)
          // .slice(0, sliceMintues)
          .map((_, index) => {
            const value = index + 1;
            return {
              label: `${pad(value)}`,
              value: `${pad(value)}`,
              index,
            };
          })
      )
      .reverse();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectHour, selectMinute]);

  const onSelectMonth = (value) => {
    const diff_days = months[value - 1].days - selectDate;
    if (diff_days < 0) {
      setSelectDate(`${pad(months[value - 1].days)}`);
    }
    setSelectMonth(value);
  };

  const onSelectDate = (value) => {
    setSelectDate(value);
  };

  const onSelectYear = (e) => {
    setSelectYear(e);
  };

  const onSelectHour = (e) => {
    if (e < +today.hours) {
      setSelectMinute(59);
    } else {
      const newToday = getCurrentLocalDateTime();
      setSelectMinute(pad(newToday.minutes));
    }
    setSelectHour(e);
  };

  const onSelectMintue = (e) => {
    setSelectMinute(e);
  };

  return {
    onSelectDate,
    onSelectHour,
    onSelectMintue,
    onSelectMonth,
    onSelectYear,
    selectDate,
    selectHour,
    selectMinute,
    selectMonth,
    selectYear,
    optionsDates,
    optionsHours,
    optionsMintues,
    optionsMonths,
    optionsYears,
    setSelectDate,
    setSelectHour,
    setSelectMinute,
    setSelectMonth,
    setSelectYear
  };
}

export default useDateDropdown;
